import React, { useEffect, useState } from 'react';
import PlayerPreviewModal from '../Modals/PlayerPreviewModal';
import { feedRequest } from '../../lib/feedApi';

export default function FeedPlayerPreview({ id, onClose }: { id: string; onClose: () => void }) {
  const [retry, setRetry] = useState(0);
  const [state, setState] = useState<{
    id: string;
    player?: Users.User;
    offerHref?: string | null;
    error?: boolean;
  } | null>(null);
  useEffect(() => {
    const controller = new AbortController();
    setState(null);
    feedRequest<{ player: Users.User; offerHref: string | null }>(
      `/api/feed-player?id=${encodeURIComponent(id)}`,
      'GET',
      undefined,
      controller.signal,
    )
      .then(data => {
        if (!controller.signal.aborted) setState({ id, ...data });
      })
      .catch(() => {
        if (!controller.signal.aborted) setState({ id, error: true });
      });
    return () => controller.abort();
  }, [id, retry]);
  const current = state?.id === id ? state : null;
  return (
    <PlayerPreviewModal
      user={current?.player || null}
      onClose={onClose}
      offerHref={current?.offerHref}
      showAvailability={false}
      loading={!current}
      loadError={!!current?.error}
      onRetry={() => setRetry(value => value + 1)}
    />
  );
}
